import { useState, useEffect } from 'react';
import { useBackendSettings } from './useBackendSettings';

export const useExperimentsAnnouncement = () => {
  const [showTour, setShowTour] = useState(false);
  const { settings, saveSettings, isLoading: isLoadingSettings } = useBackendSettings();

  useEffect(() => {
    // Wait for settings to load from backend before deciding whether to show tour
    if (isLoadingSettings) {
      return;
    }

    // Check if user has completed the announcement
    const hasCompletedTour = settings?.experiments_announcement_completed === 'true';

    // Show announcement automatically if never completed
    if (!hasCompletedTour) {
      setShowTour(true);
    } else {
      setShowTour(false);
    }
  }, [settings, isLoadingSettings]);

  const completeTour = () => {
    saveSettings({
      experiments_announcement_completed: 'true',
      experiments_announcement_skipped: 'false',
    });
    setShowTour(false);
  };

  const skipTour = () => {
    // Mark as skipped but not completed, so the announcement re-offers on next visit
    saveSettings({ experiments_announcement_skipped: 'true' });
    setShowTour(false);
  };

  const resetTour = () => {
    saveSettings({
      experiments_announcement_completed: 'false',
      experiments_announcement_skipped: 'false',
    });
    setShowTour(true);
  };

  // Check if announcement was skipped but never completed (parity with the
  // other tour hooks' return shape)
  const wasSkipped =
    settings?.experiments_announcement_skipped === 'true' &&
    settings?.experiments_announcement_completed !== 'true';

  return {
    showTour,
    isLoading: isLoadingSettings,
    completeTour,
    skipTour,
    resetTour,
    wasSkipped,
  };
};
